import React from 'react';
import { withAppContext, getToken } from '@ctsu/loader';
import {
  Header, Footer, HelpContainer, Notification
} from '@ctsu/react-ctsu-ui';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { regulatoryTopNavRoutes } from 'routes/appRoutes';
import { connect } from 'react-redux';
import { NavSpine } from '@ctsu/nav-spine';
import { bindActionCreators } from 'redux';
import buildInfo from 'components/BuildInfo/build_info-lock.json';
import CheckQueuedStatus from 'containers/cirb/capProcessQueue/CheckQueuedStatus';
import ProcessBanner from '../../containers/cirb/capProcessQueue/ProcessBanner';
import withRouter from './WithRouter';
import DocTitle from './DocTitle';

function Logout() {
  return (
    <NavLink to="/logout" title="logout">
      Logout
    </NavLink>
  );
}

function AppContent(props) {
  const {
    context, flag, summaryData, children
  } = props;
  const location = useLocation();
  const { session, application } = context;

  const getDshKeyFromUrl = () => {
    const $key = location?.pathname.toUpperCase().substr(1);
    const dshKey = _.isEmpty($key) ? 'PACKET' : $key;
    return dshKey;
  };

  const getBanner = () => <ProcessBanner />;

  return (
    <div>
      <DocTitle />
      <Header
        appName={application.appName}
        displayAppName="Regulatory"
        key="regulatory.header"
        routes={regulatoryTopNavRoutes}
        subName=""
        stickyData={summaryData}
        showSummary={flag}
        logout={Logout}
        externalComponents={null}
        dbName={application.dbName}
        userPermissions={session && session.userPermissions}
        impersonateContext={context}
        userFirstLast={session && session.userFirstLast}
        fnToken={getToken}
        username={session && session.username}
        impersonateLevel={session && session.impersonateLevel}
        lastLogin={session && session.lastLogin}
        ctepId={session && session.ctepId}
        pwdExpiryDays={session && session.pwdExpiryDays}
        coreVersion="v1"
        optionalfield={getBanner}
      />
      <CheckQueuedStatus />
      <Notification
        fnToken={getToken}
        appName={application.appName}
        isMaintainer
        coreVersion={`${process.env.REACT_APP_PERSON_API_VERSION}`}
        appContext={context}
        isPublic
      />
      <div className="main app-body">
        <div className="app-spacing">
          <div className="app-body-content">
            {session && (
              <>
                <HelpContainer
                  appUrl={process.env.REACT_APP_ORIGIN}
                  getToken={getToken}
                  appName={application.appName}
                  appContext={getDshKeyFromUrl()}
                />
                <NavSpine
                  userContext={session}
                  appName={application.appName}
                  appRoot={`${process.env.REACT_APP_ORIGIN}`}
                  getToken={getToken}
                />
              </>
            )}
          </div>
          {children}
          <Outlet />
        </div>
      </div>
      <Footer
        buildInfo={{
          buildVersion: buildInfo.build_version,
          buildDate: buildInfo.build_date
        }}
        releaseNotes="https://www.ctsu.org/master/simplepage.aspx?ckey=REGULATORY-RELEASE-NOTES"
        dbName={application.dbName}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  flag: state.common.isSummary,
  summaryData: state.common.summaryData
});

const withConnectState = connect(mapStateToProps, (dispatch) => bindActionCreators({}, dispatch));

export default withConnectState(withRouter(withAppContext(AppContent)));
